export function sortFirms(firms, sortField, sortDirection) {
    const sorted = [...firms];
    
    sorted.sort((a, b) => {
        let aVal = a[sortField];
        let bVal = b[sortField];

        if (typeof aVal === 'string') {
            return sortDirection === 'asc' 
                ? aVal.localeCompare(bVal)
                : bVal.localeCompare(aVal);
        }
        
        return sortDirection === 'asc' ? aVal - bVal : bVal - aVal;
    });

    return sorted;
}

export function filterFirms(firms, filters) {
    let result = [...firms];

    if (filters.searchTerm) {
        const term = filters.searchTerm.toLowerCase();
        result = result.filter(f => 
            f.name.toLowerCase().includes(term) || 
            (f.notes && f.notes.toLowerCase().includes(term))
        );
    }

    if (filters.selectedStrategies && filters.selectedStrategies.length > 0) {
        result = result.filter(f => 
            f.strategies.some(s => filters.selectedStrategies.includes(s))
        );
    }

    if (filters.selectedCities && filters.selectedCities.length > 0) {
        result = result.filter(f => 
            f.offices.some(o => filters.selectedCities.includes(o.city))
        );
    }

    if (filters.employeeMin) {
        result = result.filter(f => f.totalEmployees >= parseInt(filters.employeeMin));
    }

    if (filters.employeeMax) {
        result = result.filter(f => f.totalEmployees <= parseInt(filters.employeeMax));
    }

    return result;
}

export function getUniqueStrategies(firms) {
    const strategies = new Set();
    firms.forEach(f => f.strategies.forEach(s => strategies.add(s)));
    return Array.from(strategies).sort();
}

export function getUniqueCities(firms) {
    const cities = new Set();
    firms.forEach(f => f.offices.forEach(o => cities.add(o.city)));
    return Array.from(cities).sort();
}